import React from "react";

import { Input } from "../Input";

type Props = React.ComponentProps<typeof Input>;

export const InputDate: React.FC<Props> = (props) => {
  return <Input mask={"99.99.9999"} {...props} />;
};
